/** `REACT_APP_EXAME_IMAGEM_ENABLED`: desligada por padrão; só `"true"` liga. Lida na chamada para o teste trocar. */
export const exameImagemHabilitado = (): boolean =>
  process.env.REACT_APP_EXAME_IMAGEM_ENABLED === 'true'
